import { Injectable } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { UntilDestroy } from '@ngneat/until-destroy';
import { TranslationId } from '@platform-frontend/util';
import { Observable, filter, map, merge, startWith, tap } from 'rxjs';

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})
export class TranslationService {
  constructor(private translocoService: TranslocoService) {}

  executeOnLangChange(callback: (activeLang: string) => void): Observable<string> {
    return merge(
      this.translocoService.events$.pipe(
        filter(e => e.type === 'langChanged' || e.type === 'translationLoadSuccess'),
        map(e => e.payload.langName)
      ),
      this.translocoService.langChanges$
    ).pipe(
      startWith(this.translocoService.getActiveLang()),
      tap(activeLang => setTimeout(() => callback(activeLang), 0))
    );
  }

  translate(translationId: TranslationId): string {
    return this.translocoService.translate(
      ((translationId.scope && translationId.key.startsWith(translationId.scope)) || !translationId.scope ? '' : translationId.scope + '.') + translationId.key,
      translationId.params,
      this.translocoService.getActiveLang()
    );
  }
}
